import React, {Component} from 'react'
import PropTypes from 'prop-types'
import JobItemsModal from './JobItemsModal'

class JobItems extends Component {
    state = {
        visible: false,
    }

    _toggleModal = () => {
        this.setState({
            visible: !this.state.visible,
        })
    }

    render() {
        const {sessionId} = this.props
        const {visible} = this.state

        return (
            <div className="JobItems">
                <span onClick={this._toggleModal} className="cursor-pointer text-primary">{sessionId}</span>
                {visible && (
                    <JobItemsModal toggleModal={this._toggleModal} sessionId={sessionId} visible={visible}/>
                )}
            </div>
        )
    }
}

JobItems.propTypes = {
    sessionId: PropTypes.string.isRequired
}

export default JobItems